export default "__VITE_ASSET__DYuD7OP___"